import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ModalContext } from 'App';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import * as action from '../action';
import * as c from '../constant';
import VerifyReceipt from '../components/VerifyReceipt';

function BTAXContent({
  transactionInfo,
  showTransaction,
  clearTransaction,
  isLoading,
  match,
  taxpayer,
  taxpayerProfile,
}) {
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const formatPeriod = (data) => {
    return data
      ? data
          .replace('-1', ' - 1st quarter')
          .replace('-2', ' - 2nd quarter')
          .replace('-3', ' - 3rd quarter')
          .replace('-4', ' - 4th quarter')
      : '---';
  };

  const showVerifyReceipt = (status) => {
    return ['WAITING FOR PAYMENT', 'PAID', 'FOR PICK-UP', 'PENDING'].includes(
      status
    );
  };

  const handleVerifyReceipt = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayerProfile, 'photo') !==
                        '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(taxpayerProfile, 'photo')}
                          />
                        ) : (
                          getInitials(`${_.get(taxpayer, 'account_name')}`)
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'account_name') || '-'}`}
                      </h1>
                    </div>
                  </div>
                  {showVerifyReceipt(
                    _.get(transactionInfo, 'attributes.transaction_status')
                  ) && (
                    <div className="d-flex justify-content-end mb-3">
                      <button
                        onClick={handleVerifyReceipt}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold"
                        type="button"
                      >
                        Assess Payment Receipt
                      </button>
                    </div>
                  )}

                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Account Details</Tab>
                    </TabList>
                    <TabPanel>
                      <TransactionInformation
                        module="BTAX"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="col-12 p-3">
                        <table className="transaction-table table table-borderless table-sm ">
                          <tbody>
                            <tr>
                              <td className="text-dark" width="250">
                                Account Name
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'account_name') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                BIN
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {(
                                    _.get(taxpayer, 'bin') || '--'
                                  ).toUpperCase()}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Period
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>{_.get(taxpayer, 'period') || '--'}</b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                From
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {formatPeriod(
                                    _.get(taxpayer, 'payment_from')
                                  )}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                To
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {formatPeriod(_.get(taxpayer, 'payment_to'))}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Date Processed
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {_.get(taxpayer, 'date_processed')
                                    ? moment(
                                        `${_.get(taxpayer, 'date_processed')}`
                                      ).format('MMM DD, YYYY')
                                    : '--'}
                                </b>
                              </td>
                            </tr>
                            <tr>
                              <td className="text-dark" width="250">
                                Expiration Date
                              </td>
                              <td className="text-dark" width="1">
                                :
                              </td>
                              <td>
                                <b>
                                  {_.get(taxpayer, 'expiration_date')
                                    ? moment(
                                        `${_.get(taxpayer, 'expiration_date')}`
                                      ).format('MMM DD, YYYY')
                                    : '--'}
                                </b>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

BTAXContent.propTypes = {
  // selectedTransaction: PropTypes.string.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  // approveTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayerProfile:
    _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
      business_establishments:
        _.get(
          api,
          `${c.SHOW_TRANSACTION}.item.included.businessEstablishments`
        ) || [],
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(BTAXContent);
